import api from './client';

export interface AuditEntry {
  id: number;
  created_at: string;
  action: string;
  user_id: number;
  display_name?: string;
  username?: string;
  changes: Record<string, { old: any; new: any }>;
}

export interface AuditListResponse {
  items: AuditEntry[];
  total: number;
}

export const getEmployeeAuditLog = (employeeId: number, page = 1, pageSize = 20) =>
  api.get<AuditListResponse>('/audit', {
    params: {
      entity_type: 'employee',
      entity_id: employeeId,
      page,
      per_page: pageSize,
    },
  }).then(r => r.data);
